var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00098 3C4.23955 3 2.00098 5.23858 2.00098 8V12C2.00098 12.2011 2.0128 12.3991 2.0357 12.5932L2.06011 12.8001L1.99985 12.9996L2 13V21.8258L2.65079 22.585L2 21.8258L6.78747 17.7222C7.3312 17.2562 8.02371 17 8.73985 17H19.001C21.7624 17 24.001 14.7614 24.001 12V8C24.001 5.23858 21.7624 3 19.001 3H7.00098ZM0.000976562 8C0.000976562 4.13401 3.13498 1 7.00098 1H19.001C22.867 1 26.001 4.13401 26.001 8V12C26.001 15.866 22.867 19 19.001 19H8.73985C8.50114 19 8.2703 19.0854 8.08906 19.2407L3.30158 23.3443L2.65706 22.5923L3.30158 23.3443C2.00424 24.4563 0 23.5345 0 21.8258V13C0 12.881 0.0105035 12.7638 0.030777 12.6495C0.0110422 12.4354 0.000976562 12.2188 0.000976562 12V8Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentLogo);
export default __webpack_public_path__ + "static/media/CommentLogo.4bf0976c7dc8063e4ba632d0382ff602.svg";
export { ForwardRef as ReactComponent };